import React, { Component } from "react";
import { Image } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NoDataFound from "../../component/NoDataFound";
import { isValidArray } from "../../helper";
import news1 from "../../../src/assets/newsImages/news-1.webp";
import news3 from "../../../src/assets/newsImages/news-3.jpg";
import news4 from "../../../src/assets/newsImages/news-4.jpg";
import news5 from "../../../src/assets/newsImages/news-5.webp";
import news6 from "../../../src/assets/newsImages/news-6.jpg";
import news7 from "../../../src/assets/newsImages/news-7.webp";
import news8 from "../../../src/assets/newsImages/piyush-goel-01.jpg";
import news9 from "../../../src/assets/newsImages/piyush-goel-02.jpg";
import news10 from "../../../src/assets/newsImages/piyush-goyal-03.jpg";
import news11 from "../../../src/assets/newsImages/25th_jan.jpg";
import news12 from "../../../src/assets/newsImages/30th_march.jpeg";
import news13 from "../../../src/assets/newsImages/news-13.jpg";
import news14 from "../../../src/assets/newsImages/news-14.jpg";
import news15 from "../../../src/assets/newsImages/news-15.jpg";
import { getUpdate, getHeading } from "../../actions/pmgTeam.action";

class LatestNews extends Component {
  state = {
    latestNews: [
      {
        title:
          "Project Monitoring Group monitored over 1912 projects worth Rs 64 lakh crores; facilitated resolution of 5,438 issues",
        link: "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1884181",
        image: news14,
        description:
          "Till date, PMG has monitored 1912 projects with investment worth Rs 64 lakh crores. These include all important mega infrastructure projects including high impact GatiShakti projects and critical infrastructure gap projects. Out of these, 294 projects with investment worth Rs 7.23 lakh crores have been added since January 2022.",
        pubDate: "Dec 16, 2022 T"
      },
      {
        title:
          " 696 issues pertaining to big ticket projects resolved through PRAGATI and Project Monitoring Group mechanism in last two years",
        link: "https://pib.gov.in/PressReleasePage.aspx?PRID=1883681",
        image: news15,
        description:
          "Minister of State, PMO, Dr. Jitendra Singh says the platforms have improved coordination among the stakeholders and helped better monitoring and faster implementation of projects by resolving issues through discussions and exchange of information among the stakeholders.",
        pubDate: "Dec 15, 2022 T"
      },
      {
        title:
          "Department for Promotion of Industry and Internal Trade (DPIIT) reviews 40 critical infrastructure projects across India",
        link: "https://pib.gov.in/PressReleasePage.aspx?PRID=1854736",
        image: news13,
        description:
          "Special Secretary, Department for Promotion of Industry and Internal Trade (DPIIT), Ministry of Commerce and Industry with the Project Monitoring Group (PMG Invest India) reviewed 40 critical infrastructure projects across India with issues enlisted for resolution with Ministry of Environment, Forest & Climate Change and Ministry of Railways today.",
        pubDate: "Aug 26, 2022 T"
      },
      {
        title:
          "Project Monitoring Group, DPIIT reviews 374 high impact infrastructure projects in FY 2021-22",
        link: "https://pib.gov.in/PressReleaseIframePage.aspx?PRID=1811562",
        image: news12,
        description:
          "With the co-operation and active participation of the State Governments and Ministry Officials, 374 projects with a value of approximately INR 17 lakh crore have been reviewed since April 2021 through regular review meetings. As a result, 568 issues in 248 projects worth INR 12.20 lakh crores were resolved.",
        pubDate: "Mar 30, 2022 T"
      },
      {
        title:
          "Shri Piyush Goyal reviews Fast Track Implementation of Infrastructure Projects through the Project Monitoring Group (PMG) portal",
        link: "https://pib.gov.in/PressReleaseIframePage.aspx?PRID=1792588",
        image: news11,
        description:
          "Minister of Commerce & Industry Shri Piyush Goyal reviewed the pace of implementation of infrastructure projects being monitored through the Project Monitoring Group (PMG) portal and directed that regular meeting be held with State Governments and Central Ministries to ensure timely resolution of issues.",
        pubDate: "Jan 25, 2022 T"
      },
      {
        title:
          "36 issues of 17 infra projects reviewed by Project Monitoring Group",
        link:
          "https://www.moneycontrol.com/news/business/36-issues-of-17-infra-projects-reviewed-by-project-monitoring-group-4987821.html",
        image: news10,
        description:
          "The projects which were reviewed on February 27 include BPCL's petroleum and petrochemical projects in Rasayani, Maharashtra.",
        pubDate: "Feb 28, 2020 T"
      },
      {
        title:
          "36 bottlenecks faced by 17 infra projects reviewed by Goyal-led panel",
        link:
          "https://www.business-standard.com/article/pti-stories/36-issues-of-17-infra-projects-reviewed-by-project-monitoring-group-120022801220_1.html",
        image: news8,
        description:
          "At the moment, it said, the group is handling 588 issues in 260 projects, with total anticipated investment of &#8377; 10 lakh Cr.",
        pubDate: "Feb 28, 2020 T"
      },
      {
        title:
          "Shri Piyush Goyal Reviews Infrastructure Projects on PMG Portal",
        link: "https://pib.gov.in/PressReleseDetail.aspx?PRID=1604671",
        image: news9,
        description:
          "Minister of Railways and Commerce & Industry, Shri Piyush Goyal chaired a meeting for the review of 17 large-size infrastructure projects on 27th of February in Department of Promotion of Industry and Internal Trade (DPIIT), New Delhi.",
        pubDate: "Feb 28, 2020 T"
      },
      {
        title: "PM Modi tells PMG to monitor bullet train project",
        link:
          "https://economictimes.indiatimes.com/industry/transportation/railways/modi-tells-pmg-to-monitor-bullet-train-project/articleshow/63991974.cms?from=mdr",
        image: news1,
        description:
          "Modi has tasked the PMG with monitoring the 508-km-long Mumbai-Ahmedabad highspeed rail project at an April 25 PRAGATI review meeting —he takes stock of the progress of mega projects at these meetings.",
        pubDate: "May 01, 2018 T"
      },
      {
        title: "Clear pending projects, Project Monitoring Group tells MoEF",
        link:
          "https://www.dnaindia.com/india/report-clear-pending-projects-project-monitoring-group-tells-moef-2371232",
        image: news3,
        description:
          "The ministry’s forestry wing has sent requests asking for speedier processing of cases dealing with diversion of forest land",
        pubDate: "Mar 28, 2017 T"
      },
      {
        title: "NOW e–PROJECT MONITORING SYSTEM (e-PMS) PORTAL IN RAJASTHAN",
        link:
          "https://nrinews24x7.com/now-e-project-monitoring-system-e-pms-portal-in-rajasthan/",
        image: news4,
        description:
          "Now Rajasthan too has an e-Project Monitoring System (e-PMS) Portal on the lines of the central Project Monitoring System (PMS).",
        pubDate: "Dec 24, 2016 T"
      },
      {
        title:
          "Now, Rajasthan to monitor large investment projects electron ..",
        link:
          "https://timesofindia.indiatimes.com/city/jaipur/now-rajasthan-to-monitor-large-investment-projects-electronically/articleshow/56151507.cms",
        image: news5,
        description:
          "Like the Centre, now Rajasthan too has an e-Project Monitoring System (e-PMS) portal.",
        pubDate: "Dec 24, 2016 T"
      },
      {
        title:
          "530 Stalled projects worth &#8377; 20 Lakh cr. gets green light from Prime Minister Narendra Modi",
        link:
          "https://postcard.news/530-stalled-projects-worth-rs-20-lakh-crore-gets-green-light-from-prime-minister-narendra-modi/",
        image: news6,
        description:
          "The Project Monitoring Group (PMG) which works directly under the Prime Minister of India has cleared 276 old projects, which were stalled, worth &#8377; 10 lakh cr. in the last two year",
        pubDate: "Sep 4, 2016 T"
      },
      {
        title:
          "Projects worth &#8377; 20 lakh cr. set to get green light from key PMO group",
        link:
          "https://economictimes.indiatimes.com/news/economy/finance/projects-worth-rs-20-lakh-crore-set-to-get-green-light-from-key-pmo-group/articleshow/53987956.cms?from=mdr",
        image: news7,
        description:
          "Project Monitoring Group removes bumps for 276 projects worth &#8377; 10 lakh Cr., another 258 to be cleared soon.",
        pubDate: "Sep 03, 2016 T"
      }
    ],
    isPmgActive: true,
    latestNews: [],
    headerData: {}
  };

  componentDidMount() {
    this.getInvestiListingData();
    this.getHeadingListingData();
  }

  getHeadingListingData = async () => {
    try {
      const headerDetails = await getHeading();
      console.log(headerDetails, "details");
      this.setState({ headerData: headerDetails.data.pmgUpdate });
    } catch (error) {
      console.error("Error fetching Updated data:", error);
    }
  };

  getInvestiListingData = async () => {
    try {
      const pmgInvestData = await getUpdate();
      // console.log(pmgInvestData, "pmgInvestData");

      if (pmgInvestData) {
        this.setState({
          latestNews: pmgInvestData.data
        });
      }
    } catch (error) {
      console.error("Error fetching PMG data:", error);
    }
  };

  render() {
    const { latestNews } = this.state;
    // const { pmgData } = this.state;
    const { isDesktopView } = this.props;
    let settings = {
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2.5
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.5
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    return (
      <React.Fragment>
        {isDesktopView ? null : (
          <>
            {this.state.headerData && (
              <h2 className={isDesktopView ? "" : "key-enabler-heading"}>
                {this.state.headerData.title}
              </h2>
            )}
          </>
        )}
        <div className="latestnews-wrapper">
          <div className="container">
            {isDesktopView ? (
              <>
                {this.state.headerData && (
                  <h2 className={isDesktopView ? "" : "key-enabler-heading"}>
                    {this.state.headerData.title}
                  </h2>
                )}
              </>
            ) : null}
            <Slider {...settings} className="latestnews">
              {isValidArray(latestNews) ? (
                latestNews.map((item, index) => {
                  // let pubdate = news.pubDate;
                  // let indexOf_T = pubdate.indexOf("T");
                  // let updatedDate = pubdate.slice(0, indexOf_T);
                  let pubdate = item.releaseDate;
                  const timestamp = pubdate;
                  const date = new Date(timestamp);

                  const day = date.getDate();

                  const month = date.getMonth() + 1; // Months are 0-indexed in JavaScript
                  const monthName = date.toLocaleString("default", {
                    month: "short"
                  }); // "March"
                  const year = date.getFullYear();

                  const paddedDay = day < 10 ? `0${day}` : day;
                  const paddedMonth = month < 10 ? `0${month}` : month;

                  const formattedDate = `${monthName}  ${paddedDay}, ${year}`;

                  // const [day, month, year] = pubdate.split("-");

                  // // Create a new Date object using the parsed parts
                  // const date = new Date(year, month - 1, day);

                  // Define an array of month names
                  const monthNames = [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                  ];

                  // Format the date using the desired format
                  // const formattedDate = `${
                  //   monthNames[date.getMonth()]
                  // } ${day}, ${year}`;

                  // let updatedDate = new Date(pubdate).toLocaleDateString();
                  return (
                    <div
                      className="slide-item latestnews-card"
                      key={`news-${index}`}
                    >
                      <a
                        href={item.pageUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {/* <Image src={item.image[0].s3Url} alt={item.title} /> */}
                        {item.image && item.image.length > 0 && (
                          <Image src={item.image[0].s3Url} alt={item.title} />
                        )}
                      </a>
                      <div className="latestnews-data">
                        <div className="news-date">{formattedDate}</div>
                        <div className="news-title">
                          <a
                            href={item.pageUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item.title}
                          </a>
                        </div>
                        <div
                          className="news-desc"
                          // dangerouslySetInnerHTML={{ __html: news.description }}
                        >
                          {item.description}
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <NoDataFound />
              )}
            </Slider>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default LatestNews;
